import { Box } from '@mui/material'
import { getFirstItem } from 'lib/util'
import CellHOC from '@platform/react/hoc/list/cell'
import Image from 'ui/Element/Image'

const styles = theme => ({
  root: {
    width: '2.5rem',
    height: '2.5rem',
    display: 'flex',
  },
})

/**
 * Display the image for a given product.
 *
 * @param {Object} classes  styling for the cell
 * @param {Object} props    props for the cell
 *
 * @returns {JSX.Element}
 */
const ListItemCellProductImage = (classes, props = {}) => {
  const { avatar } = props
  const attachment = getFirstItem(avatar)

  return (
    <Box className={classes.root}>
      <Image
        shape={'circle'}
        attachment={attachment}
        fallbackIcon={{
          name: 'device',
          color: 'white',
          background: 'gray.930',
          padding: 1,
          size: 24,
        }}
      />
      {/* TODO: Remove commented out fallback behavior after all avatars have been migrated. */}
      {/* <Image */}
      {/*   {...avatar ? { */}
      {/*     attachment: avatar, */}
      {/*   } : { */}
      {/*     api, */}
      {/*     value: ref, */}
      {/*   }} */}
      {/*   fallbackPicture={'GenericDevice.png'} */}
      {/* /> */}
    </Box>
  )
}

export default CellHOC(ListItemCellProductImage, styles)
